<template>
  <div class="height-100-p">
     <el-form :model="editForm" :rules="editFormRules" ref="editForm" size="mini">
     <el-table
        :data="contactInfo"
        v-loading="customerMasterRecord.loadingSearch"
        id="minimumManagement-data-list"
        ref="dayOfServiceManagementTable"
        size="mini"
        tooltip-effect="dark"
        class="dark-blue-table"
        :empty-text="$t('common.notAbleToFindRecords')"
        @sort-change="handleSortChange"
        stripe
    >
      <el-table-column prop="type" label="Roles" :min-width="6" align="center" sortable="custom">
        <template slot-scope="scope">
            <template  v-if="!scope.row.edit">
          <el-tooltip effect="dark" :content="getContactRoleLabel(scope.row.roles)" placement="top">
            <span>
              {{getContactRoleLabel(scope.row.roles)}}
            </span>
          </el-tooltip>
        </template>
            <template v-else>
              <el-form-item prop="type" ref="type">
                <select-list-billing
                  :value.sync="editForm.roles"
                  :data="contactTypes"
                  label-field="label"
                  value-field="value"
                  ref="filter-region-select" />
              </el-form-item>
            </template>
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('account.contactInfo.name')" :min-width="6" align="center" sortable="custom">
        <template slot-scope="scope">
            <template  v-if="!scope.row.edit">
          <el-tooltip effect="dark" :content="scope.row.name" placement="top">
            <span>
              {{scope.row.name}}
            </span>
          </el-tooltip>
        </template>
            <template v-else>
              <el-form-item prop="name" ref="name">
                <el-input v-model="editForm.name"   :placeholder="$t('account.contactInfo.name')" />
              </el-form-item>
            </template>
        </template>
      </el-table-column>

      <el-table-column prop="email" :label="$t('account.contactInfo.email')" :min-width="6" align="center" sortable="custom">
        <template slot-scope="scope">
          <template v-if="!scope.row.edit">
            <el-tooltip effect="dark" :content="scope.row.email" placement="top">
            <span>
              {{scope.row.email}}
            </span>
          </el-tooltip>
        </template>
            <template v-else>
              <el-form-item prop="email" ref="email">
                <el-input v-model="editForm.email"   :placeholder="$t('account.contactInfo.email')" />
              </el-form-item>
            </template>
        </template>
      </el-table-column>

      <el-table-column prop="additionalEmail" :label="$t('account.contactInfo.additionalEmail')" :min-width="7" align="center" sortable="custom">
        <template slot-scope="scope">
          <template v-if="!scope.row.edit">
          <span>
            {{scope.row.additionalEmail}}
          </span>
        </template>
            <template v-else>
              <el-form-item prop="additionalEmail" ref="additionalEmail">
                <el-input v-model="editForm.additionalEmail"   :placeholder="$t('account.contactInfo.additionalEmail')" />
              </el-form-item>
            </template>
        </template>
      </el-table-column>
      <el-table-column prop="phone" :label="$t('account.contactInfo.phone')" :min-width="7" align="center" sortable="custom">
        <template slot-scope="scope">
            <template  v-if="!scope.row.edit">
          <span>
            {{ scope.row.phone }}
          </span>
        </template>
            <template v-else>
              <el-form-item prop="phone" ref="phone">
                <el-input v-model="editForm.phone"   :placeholder="$t('account.contactInfo.phone')" />
              </el-form-item>
            </template>
        </template>
      </el-table-column>
      <el-table-column prop="additionalPhone" :label="$t('account.contactInfo.additionalPhone')" :min-width="7" align="center" sortable="custom">
        <template slot-scope="scope">
          <template v-if="!scope.row.edit">
          <span>
            {{ scope.row.additionalPhone }}
          </span>
        </template>
            <template v-else>
              <el-form-item prop="additionalPhone" ref="additionalPhone">
                <el-input v-model="editForm.additionalPhone"   :placeholder="$t('account.contactInfo.additionalPhone')" />
              </el-form-item>
            </template>
        </template>
      </el-table-column>
      <el-table-column
        prop="active"
        :label="$t('barCodeUserType.active')"
        :min-width="5"
        align="center"
        sortable="custom">
        <template slot-scope="scope">
          <template v-if="!scope.row.edit">
            <i v-if="scope.row.active" class="el-icon-success green-success"></i>
            <i v-else class="el-icon-error red-error"></i>
          </template>
          <template v-else>
            <el-form-item prop="active" ref="active">
              <el-checkbox v-model="editForm.active"  :placeholder="$t('account.contactInfo.active')" />
            </el-form-item>
          </template>
        </template>
      </el-table-column>


      <el-table-column prop="action" v-if="!isProfileView && isEditable" :label="$t('common.options')" :min-width="4" align="center">
        <template slot-scope="scope" >
          <template v-if="showEditButton()">
            <el-tooltip
              class="item el-icon-edit-tooltip"
              effect="dark"
              :enterable="false"
              :content="$t('warehouse.orderEntry.edit')"
              placement="top-start"
              >
              <i class="el-icon-edit icon-action" @click="handleEdit(scope.row)"></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :enterable="false"
              :content="$t('common.delete')"
              placement="top-start">
              <i class="el-icon-delete icon-action" @click="handleDelete(scope.row)"></i>
            </el-tooltip>
          </template>
          <template v-else-if="scope.row.edit">
            <el-button icon="el-icon-success" circle size="mini" @click="handleUpdate()"></el-button>
            <el-button icon="el-icon-circle-close" circle size="mini" @click="cancelEdit(scope.row)"></el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    </el-form>
    <div class="pagination-footer" v-show="totalRows > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('common.total') }}</span>
           {{ totalRows }}
      </span>
      <el-pagination
          @size-change="handleSearchChangeLimit"
          :page-sizes="sizes"
          :page-size="contactsFilters.maxResults"
          :current-page.sync="contactsFilters.page"
          @current-change="handleSearchChangePage"
          :total="totalRows"
          layout="sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import { ACCOUNT_SEARCH_CONTACT_INFO, CONTACT_INFO_SAVE, CONTACT_INFO_DELETE } from '@/store/actions';
import constants from '@/utils/constants';
import transformLabels from '@/plugins/unitDataTransformLabels';
import SelectListBilling from '@/components/billing/SelectListBilling/SelectListBilling';
//  import DetailMinimum from './components/detailMinimum/DetailMinimum';
//  import AddMinimum from './components/addMinimum/AddMinimum';

export default {
  name: 'SearchSummaryList',
  mixins: [transformLabels],
  props: {
    isEditable: {
      type: Boolean,
      default: true,
      required: false
    },
  },
  computed: {
    ...mapGetters(['customerMasterRecord']),
    contactInfo() {
      const list = this.customerMasterRecord.contactInfo;
      if (!list || !Array.isArray(list)) {
        return [];
      }
      return list;
    },
    customerId() {
      return this.customerMasterRecord.list[0]?.id || null;
    },
    totalRows() {
      return this.customerMasterRecord.totalContacts;
    },
    isProfileView() {
      return this.customerMasterRecord.isProfileView;
    },
    contactsFilters() {
      return this.customerMasterRecord.contactsFilters;
    }
  },
  components: {
    SelectListBilling
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,
      isEditMode: false,
      contactTypes: constants.ACCOUNTS.CONTACT_TYPES,
      searchFilters: {
        maxResults: constants.TABLES.DEFAULT_LIMIT,
        page: 1,
        contactType: 'ALL'
      },
      editForm: {
        id: null,
        type: '',
        roles: '',
        name: '',
        email: '',
        additionalEmail: '',
        phone: '',
        additionalPhone: '',
        accountId: null,
        active: true
      },
      editFormRules: {
        type: [
          {
            required: true,
            message: this.$t('account.error.fieldRequired'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('account.error.fieldRequired'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: false,
            message: this.$t('account.error.fieldRequired'),
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: false,
            message: this.$t('account.error.fieldRequired'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  onMounted() {
    this.handleSearchChangePage();
  },

  methods: {
    getContactRoleLabel(role) {
      const found = this.contactTypes.find((type) => type.value.toLowerCase() === role.toLowerCase());
      return found ? found.label : role;
    },
    handleSearchChangePage(val) {
      this.searchFilters.page = val || this.searchFilters.page;
      this.$store.dispatch(ACCOUNT_SEARCH_CONTACT_INFO, { accountId: this.customerId, filters: this.searchFilters });
    },
    handleSearchChangeLimit(val) {
      this.searchFilters.maxResults = val;
      this.searchFilters.page = 1;
      this.$store.dispatch(ACCOUNT_SEARCH_CONTACT_INFO, { accountId: this.customerId, filters: this.searchFilters });
    },
    showEditButton() {
      return !this.isEditMode && this.isEditable;
    },
    handleEdit(row) {
      this.isEditMode = true;
      row.edit = true;
      this.editForm.id = row.id;
      this.editForm.type = row.roles;
      this.editForm.roles = row.roles;
      this.editForm.name = row.name;
      this.editForm.email = row.email;
      this.editForm.additionalEmail = row.additionalEmail;
      this.editForm.phone = row.phone;
      this.editForm.additionalPhone = row.additionalPhone;
      this.editForm.accountId = row.accountId;
      this.editForm.active = row.active;
    },
    handleUpdate() {
      this.$refs.editForm.validate(async (valid, validationsErrors) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch(CONTACT_INFO_SAVE, this.editForm)
            .then((response) => {
              loading.close();
              if (response && response.message) {
                this.$message.success(response.message);
              }
              this.clearEdit();
              this.$store.dispatch(ACCOUNT_SEARCH_CONTACT_INFO, { accountId: this.customerId, filters: this.searchFilters });
            })
            .catch(() => {
              loading.close();
            });
        } else {
          let errorMessage = '';
          Object.keys(validationsErrors).forEach((key) => {
            validationsErrors[key].forEach((validation) => {
              errorMessage += `${validation.message}. `;
            });
          });
          this.$message.warning(errorMessage);
        }
      });
    },
    clearEdit() {
      this.$refs.editForm.resetFields();
      this.isEditMode = false;
      // this.$store.dispatch('shuttleFile/setEditingShuttleFile', false);
    },
    cancelEdit(row) {
      this.clearEdit();
      row.edit = false;
    },
    handleSortChange() {
      this.$store.dispatch(ACCOUNT_SEARCH_CONTACT_INFO, { accountId: this.customerId, filters: this.searchFilters });
    },
    handleDelete(row) {
      this.$confirm(`Name: ${row.name}`, this.$t('account.contactInfo.confirmDelete'), {
        confirmButtonText: this.$t('common.yes'),
        cancelButtonText: this.$t('common.no'),
        type: 'warning'
      }).then(() => {
        Message.closeAll();
        const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
        this.$store
          .dispatch(CONTACT_INFO_DELETE, row.id)
          .then((response) => {
            loading.close();
            if (response && response.message) {
              this.$message.success(response.message);
            }
            this.$store.dispatch(ACCOUNT_SEARCH_CONTACT_INFO, { accountId: this.customerId, filters: this.searchFilters });
          })
          .catch(() => {
            loading.close();
          });
      }).catch(() => {
      });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
  .expiredDate {
    color:#ed1c25;
  }
</style>
